import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { getApiBase } from '../utils/apiBase';

const API = getApiBase();

/**
 * Read-only usage/limit snapshot from billing or per-archive endpoint.
 * Does not block any actions — observability for future upgrade prompts.
 */
export function useUsageLimits({ treeId = null, enabled = true } = {}) {
  const [snapshot, setSnapshot] = useState(null);
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError(null);
    try {
      if (treeId) {
        const { data } = await axios.get(`${API}/trees/${treeId}/usage-limits`);
        setSnapshot(data);
      } else {
        const { data } = await axios.get(`${API}/billing/me`);
        setSnapshot(data.usage_limits || null);
      }
    } catch (err) {
      setError(err);
      setSnapshot(null);
    } finally {
      setLoading(false);
    }
  }, [enabled, treeId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    snapshot,
    loading,
    error,
    refresh,
    enforcementEnabled: snapshot?.enforcement_enabled === true,
  };
}
